import { LogOut } from "lucide-react";
import { useAuth } from "../lib/auth-context";
import { Button } from "./ui/button";

export default function TopBar() {
    const { user, organisation, logout } = useAuth();
    const logo = organisation?.branding?.logo_signed_url;
    return (
        <header
            data-testid="app-topbar"
            className="flex h-14 items-center justify-between border-b border-neutral-200 bg-white px-6"
        >
            <div className="flex items-center gap-3">
                {logo ? (
                    <img
                        src={logo}
                        alt="logo"
                        data-testid="org-logo"
                        className="h-7 w-7 rounded-md object-cover border border-neutral-200"
                    />
                ) : (
                    <div
                        className="h-7 w-7 rounded-md border border-neutral-200 flex items-center justify-center text-[10px] font-semibold text-neutral-600"
                        style={{ background: organisation?.branding?.accent_color || "#f5f5f5", color: "#fff" }}
                        data-testid="org-logo-fallback"
                    >
                        {organisation?.name?.[0] ?? "A"}
                    </div>
                )}
                <span data-testid="org-name" className="text-sm font-medium text-neutral-900">
                    {organisation?.name ?? "Acme Labs"}
                </span>
            </div>
            <div className="flex items-center gap-4">
                <div className="text-right leading-tight">
                    <div data-testid="user-name" className="text-sm font-medium text-neutral-900">
                        {user?.name}
                    </div>
                    <div data-testid="user-role" className="text-[11px] uppercase tracking-wider text-neutral-500">
                        {user?.role}
                    </div>
                </div>
                <Button
                    variant="ghost"
                    size="sm"
                    onClick={logout}
                    data-testid="logout-btn"
                    className="text-neutral-700 hover:text-neutral-900"
                >
                    <LogOut size={15} className="mr-1.5" />
                    Sign out
                </Button>
            </div>
        </header>
    );
}
